<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "RentenClearUpToolSinglePage",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="ClearUpToolList"></CMSSinglePage>
</template>

<style scoped>

</style>
